<template>
    <div>
        <el-row>
            <el-row>
            <el-col :span="3" style="margin-top:10px;">
                <span style="">讲者列表</span>
            </el-col>
            <el-col :span="20" style="">
                <div style="width: 100%">
                    <el-button v-if="saveOnOff" type="success" size="small" @click.stop="addactualBoolModel()"
                               style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                        <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                        添加
                    </el-button>
                </div>
            </el-col>
            </el-row>
            <el-col
                    style="border: 1px solid #ededed;width: 350px;height: 100px;margin-top: 10px;margin-right: 15px;position:relative"
                    v-for="(item,i) in formParticipant.speakerList" :key="i" >
                <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                    <img src="../../../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
                </div>

                <span style="position: relative;top: -45px;margin-left: 26px">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                     <span style="color: #4D586D;font-size: 15px;">{{item.reference_name}}</span>
                     <span v-if="item.pro_title"
                             style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                </span>
                <span
                        style="float: right;padding-top: 12px" >
                    <span  style="padding-top: 12px;color: #FF9901;margin-right: 10px">{{item.created_name}}</span>
                    <span  @click="delMeetingParticipant(item)"
                           style="color: red;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" v-if="saveOnOff">移除</span>

                </span>
                <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                  <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                      {{item.job_title}} | {{item.dept_name}}
                  </span>
                  <span style="height:16px;display: block" v-else>
                  </span>
                </p>
<!--                <div style="width: 262px;margin-top:-35px;float: right" v-if="item.mobile !== ''" >-->
<!--                    <img src="../../../../assets/images/tu5.png" alt="" >-->
<!--                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">-->
<!--                                                 {{item.mobile}}-->
<!--                                              </span>-->
<!--                </div>-->
                <div style="width: 262px;margin-top:-35px;float: right" >
                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                                                 {{item.department_name}}
                                              </span>
                </div>

                <div style="width: 262px;float: right;margin-top: -16px">
                    <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                    </span>
                    <span style="color: #4A90E2;font-size: 13px;" :style="{'color': colorFun(item)}">
                                                    {{item | filter_covegr}}
                                                </span>
                </div>

                <el-row style="margin-bottom: 10px">
                </el-row>

            </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
            <el-row>
            <el-col :span="3" style="margin-top:10px;">
                <span style="">听众列表</span>
            </el-col>
            <el-col :span="20">
                <el-button v-if="saveOnOff" type="success" size="small" @click="addactualBoolModel"
                           style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                    添加
                </el-button>
            </el-col>
            </el-row>
            <el-col
                    style="border: 1px solid #ededed;width: 350px;height: 100px;margin-top: 10px;margin-right: 15px;position:relative"
                    v-for="(item,i) in formParticipant.audienceList" :key="i" >
                <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                    <img src="../../../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
                </div>

                <span style="position: relative;top: -45px;margin-left: 26px">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                     <span style="color: #4D586D;font-size: 15px;">{{item.reference_name}}</span>
                     <span v-if="item.pro_title"
                           style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                </span>
                <span
                        style="float: right;padding-top: 12px" >
                    <span  style="padding-top: 12px;color: #FF9901;margin-right: 10px">{{item.created_name}}</span>
                    <span  @click="delMeetingParticipant(item)"
                           style="color: red;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" v-if="saveOnOff">移除</span>

                </span>
                <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                  <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                      {{item.job_title}} | {{item.dept_name}}
                  </span>
                    <span style="height:16px;display: block" v-else>
                  </span>
                </p>
                <!--                <div style="width: 262px;margin-top:-35px;float: right" v-if="item.mobile !== ''" >-->
                <!--                    <img src="../../../../assets/images/tu5.png" alt="" >-->
                <!--                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">-->
                <!--                                                 {{item.mobile}}-->
                <!--                                              </span>-->
                <!--                </div>-->
                <div style="width: 262px;margin-top:-35px;float: right" >
                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                                                 {{item.department_name}}
                                              </span>
                </div>

                <div style="width: 262px;float: right;margin-top: -16px">
                    <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                    </span>
                    <span style="color: #4A90E2;font-size: 13px;" :style="{'color': colorFun(item)}">
                                                    {{item | filter_covegr}}
                                                </span>
                </div>

                <el-row style="margin-bottom: 10px">
                </el-row>

            </el-col>
        </el-row>


        <!--        计划邀请客户-->
        <el-dialog
                :visible.sync="speakBool"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="6">
                        <div style="color: #3998F7;font-size: 22px;padding-top: 5px">计划邀请客户
                        </div>
                    </el-col>
                    <el-col :span="12" style="text-align: center">
                        <div>
                            <el-button-group>
                                <el-button :class="{active:selectType=='INSTITUTION'}" @click="checkType('INSTITUTION')" v-if="clientObj.showInstitution">医疗机构</el-button>
                                <el-button :class="{active:selectType=='RETAILSTORE'}" @click="checkType('RETAILSTORE')" v-if="clientObj.showStore">零售终端</el-button>
                                <el-button :class="{active:selectType=='DISTRIBUTOR'}" @click="checkType('DISTRIBUTOR')" v-if="clientObj.showDistributor">分销客户</el-button>
                            </el-button-group>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveActualBool()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeActualBool()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;" v-if="selectType=='INSTITUTION'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.instutionsList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getDeptList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;">{{item
                                    .institution_name}}<span
                                            style="color: #FF9901;float: right"> [已选：{{item.selectPeople_num}}人]</span></p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.institution_grade}}</span>
                                    <span> | </span>
                                    <span>医务人员总数：{{item.hcps}}人</span>
                                    <span style="color: #3b99f7;float: right">目标客户{{item.target_num}}人</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                            <el-tabs v-model="activeDepart" @tab-click="handleDepart"
                                     style="margin-left: 30px;margin-top: -12px;padding-right: 10px">
                                <el-tab-pane :label="obj.dept_name" :name="obj.dept_id" v-for="(obj,i) in
                                formParticipant.instutionsDeptList" :key="i">
                                    <el-row>
                                        <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 100px;display:flex;"
                                                v-for="(objHcp,j) in formParticipant.instutionsHcpList"
                                                :key="j">
                                            <div style="width:80px;height: 100%">
                                                <img src="../../../../assets/images/chat_header_image.png" width="100%" alt=""
                                                     style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                            </div>
                                            <div style="width: 60%;height: 100%">
                                                 <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{objHcp.reference_name}}</span>
                                                 <span style="color: #fff;border: 1px solid;background-color:#ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{objHcp.pro_title}}</span>
                                            </span>

                                                <p style="margin: 8px 0 5px">
                                              <span style="font-size: 13px;color:#B0B5B9">
                                                  {{objHcp.job_title}} | {{objHcp.dept_name}}
                                              </span>
                                                </p>
                                                <div style="font-size: 13px;color:#B0B5B9;margin-bottom: 5px"
                                                     v-if="objHcp.mobile !== ''" >
                                                    <img src="../../../../assets/images/tu5.png" alt="" style="position: relative;top: 2px">
                                                    <span style="">{{objHcp.mobile}}</span>
                                                </div>
                                                <div v-else style="height: 20px;width:100%"></div>
                                                <div style="">
                                                <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                                                </span>
                                                    <span  :style="{'color': colorFun(objHcp)}"
                                                           style="">
                                                    {{objHcp | filter_covegr}}
                                                </span>
                                                </div>
                                            </div>
                                            <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                                <p style="text-align: center;margin-top: 25px;margin-bottom: 0">
                                                    <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                                    <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                                <p style="text-align: center;margin-top: 10px" v-if="objHcp.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">
                                                        <img src="../../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">
                                                        <img src="../../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="objHcp.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'spcheck')">
                                                        <img  v-if='' src="../../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">
                                                        <img v-if='' src="../../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="objHcp.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">
                                                        <img  v-if='' src="../../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'aucheck')">
                                                        <img v-if='' src="../../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                            </el-col>
                                        </el-col>

                                    </el-row>
                                </el-tab-pane>

                            </el-tabs>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <div style="margin-top: 20px;" v-if="selectType=='RETAILSTORE'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.retailStoreList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getStorePeopleList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;position: relative"><span style="display:inline-block;width: 75%;line-height: 15px">{{item.store_name}}</span>
                                    <span style="color: #FF9901;display: inline-block;position: absolute;top: 0px;right: 0px"> [已选：{{item.selectPeople_num}}人]</span>
                                </p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.retailstore_grade}}</span>
                                    <span> | </span>
                                    <span>店员人数：{{item.clerk_num}}人</span>
                                    <span style="color: #3b99f7;float: right">本月巡店{{item.inspection_num}}次</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                                    <el-row style="margin-left: 30px">
                                        <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 80px;display:flex;"
                                                v-for="(obj,j) in formParticipant.retailStoreClerk"
                                                :key="j">
                                            <div style="width:80px;height: 100%">
                                                <img src="../../../../assets/images/chat_header_image.png" width="100%" alt=""
                                                     style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                            </div>
                                            <div style="width: 60%;height: 100%">
                                              <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{obj.reference_name}}</span>
                                                   <span style="color: #fff;border: 1px solid;background-color:#ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{obj.job_title}}</span>
                                            </span>
                                                <div style="font-size: 13px;color:#B0B5B9;margin-top: 16px"
                                                     v-if="obj.mobile !== ''" >
                                                    <img src="../../../../assets/images/tu5.png" alt="" style="position: relative;top: 3px">
                                                    <span style="">{{obj.mobile}}</span>
                                                </div>
                                                <div v-else style="height: 20px;width:100%"></div>
                                            </div>
                                            <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                                <p style="text-align: center;margin-top: 16px;margin-bottom: 0">
                                                    <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                                    <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                                <p style="text-align: center;margin-top: 10px" v-if="obj.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img src="../../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img src="../../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="obj.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'spcheck')">
                                                        <img  v-if='' src="../../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img v-if='' src="../../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="obj.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img  v-if='' src="../../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'aucheck')">
                                                        <img v-if='' src="../../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                            </el-col>
                                        </el-col>
                                    </el-row>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <div style="margin-top: 20px;" v-if="selectType=='DISTRIBUTOR'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.distributorList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getDistributorContactList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;position: relative"><span style="display:inline-block;width: 75%;line-height: 15px">{{item.distributor_name}}</span>
                                    <span style="color: #FF9901;display: inline-block;position: absolute;top: 0px;right: 0px"> [已选：{{item.selectPeople_num}}人]</span>
                                </p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.distributor_grade}}</span>
                                    <span> | </span>
                                    <span>联系人：{{item.contact_num}}人</span>
                                    <span style="color: #3b99f7;float: right">本月拜访{{item.inspection_num}}次</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                            <el-row style="margin-left: 30px">
                                <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 80px;display:flex;"
                                        v-for="(obj,j) in formParticipant.distributorContact"
                                        :key="j">
                                    <div style="width:80px;height: 100%">
                                        <img src="../../../../assets/images/chat_header_image.png" width="100%" alt=""
                                             style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                    </div>
                                    <div style="width: 60%;height: 100%">
                                              <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{obj.reference_name}}</span>
                                            </span>
                                        <div style="font-size: 13px;color:#B0B5B9;margin-top: 16px"
                                             v-if="obj.mobile !== ''" >
                                            <img src="../../../../assets/images/tu5.png" alt="" style="position: relative;top: 2px">
                                            <span style="">{{obj.mobile}}</span>
                                        </div>
                                        <div v-else style="height: 20px;width:100%"></div>
                                    </div>
                                    <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                        <p style="text-align: center;margin-top: 16px;margin-bottom: 0">
                                            <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                            <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                        <p style="text-align: center;margin-top: 10px" v-if="obj.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img src="../../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img src="../../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'spcheck')">
                                                        <img  v-if='' src="../../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img v-if='' src="../../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img  v-if='' src="../../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'aucheck')">
                                                        <img v-if='' src="../../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                    </el-col>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <el-card class="box-card" style="margin-top: 20px">
                              <span  v-for="(selectItem,i) in concatListCopy"
                                     style="display: inline-block;
                                      background: #FF9901;
                                      color: white;padding: 2px 6px;
                                      margin-top: 6px;
                                      margin-right: 10px;
                                      border-radius: 6px;
                                      line-height: 25px;font-size: 12px">
                                  {{ selectItem | filterSelectItem }}
                                  </span>
                </el-card>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "customers",
        props:{
            saveOnOff: {
                type: Boolean,
                default: false
            },
            meetInfoStatus:{
                type: String,
                default:''
            },
            activity_id:{
                type: String,
                default:''
            },
            fatherMethod: {
                type: Function,
                default: null
            },
            isF:{
                type: String,
                default:''
            },
            activity_date:{
                type: String,
                default:''
            }
        },
        data(){
            return {
                speakBool: false,
                options:[],
                formlist:{},
                identity:'',
                departmentName:'',
                formParticipant:{
                    //实际参会列表
                    concatList:[],
                    audienceList:[],
                    speakerList:[],
                    //实际参会机构列表
                    instutionsList:[],
                    //实际参会机构科室列表
                    instutionsDeptList:[],
                    instutionsHcpList:[],
                    retailStoreList:[],
                    retailStoreClerk:[],
                    distributorList:[],
                    distributorContact:[]
                },
                activeDepart:'',
                concatListCopy :[],
                instutionsHcpListCopy:[],
                selectType:'',
                clientObj:{},
            }
        },
        filters:{
            componentFliter:function (value) {

                return moment(value).format('YYYY-MM-DD')
            },
            filter_covegr:function (item) {
                if (item.calls == '0'&& item.campaigns == '0'&& item.reference_obj=='HCP'){
                    return '本月尚未覆盖'
                } else {
                    let str =''
                    if (item.calls != '0'&& item.reference_obj=='HCP'){
                        str = '本月已覆盖(医务拜访'
                    }
                    if (item.campaigns != '0'&& item.reference_obj=='HCP'){
                        if (str != ''){
                            str = str + "、科室会"
                        } else {
                            str = str + "本月已覆盖(科室会"
                        }
                    }
                    if (str!=''){
                        str = str+")"
                    }
                    return str
                }
            },
            filterSelectItem:function (item) {
                let str = ''
                if (item.invited_role === "SPEAKER") {
                    str = str + '[讲者]' + ' '
                }else if (item.invited_role === "AUDIENCE") {
                    str = str + '[听众]' + ' '
                }
                str += item.reference_name
                if(item.job_title){
                    str+=' '+item.job_title
                }
                str+=" | "
                if(item.dept_name){
                    str+=item.dept_name
                }
                str+=' '+item.department_name
                return str
            }
        },
        mounted() {
            this.getMeetingParticipant()
        },
        created() {
            this.clientObj=this.$store.getters.getClient

        },
        methods:{
            //获取会议参与者
            async getMeetingParticipant(){
                //
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });

                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id : user.tenant_id,
                        campaign_id:this.activity_id ? this.activity_id : '',
                        invited : 'T',
                        attendant:'F',
                        user_id :user.user_id,
                        role : user.role,
                        activity_date: this.activity_date
                    }
                    console.log(this.isF,33333)

                    if (this.isF === user.user_id){
                        data.isF = true
                    } else {
                        data.isF = false
                    }

                    if (!data.campaign_id){
                        // loading.close()
                        return false
                    }
                    await http.post('/wapi/Conference/getMeetingParticipant',data).then(res=>{
                        console.log(res)
                        if (res.success === true){
                            let arr = res.data
                            this.judegParticipant(arr)
                            console.log(res.data)
                        }
                    })
                    // loading.close()
                }catch (e) {
                    // loading.close()
                    return e
                }
            },
            //对会议参与者数据进行处理
            judegParticipant(arr){
                let array = arr
                let audience = []
                let speaker = []
                for (let i=0;i<array.length;i++){
                    if (array[i].invited_role === 'SPEAKER'){
                        speaker.push(array[i])
                    } else if (array[i].invited_role === 'AUDIENCE'){
                        audience.push(array[i])
                    }
                }
                this.formParticipant.audienceList = audience
                this.formParticipant.speakerList = speaker
                this.formParticipant.concatList = array
                this.concatListCopy = JSON.parse(JSON.stringify(array))

            },
            //获取机构
            async getInstutionsList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getInstutionsList',data).then(res=>{
                        if (res.success === true){
                            let array1 = res.data.array
                            let array2 = this.concatListCopy
                            for (let i=0;i<array1.length;i++){
                                array1[i].select = false
                                array1[i].selectPeople_num = 0
                                for (let j=0;j<array2.length;j++){
                                    if (array1[i].institution_id === array2[j].department_id){
                                        array1[i].selectPeople_num +=1
                                    }
                                }
                            }
                            this.formParticipant.instutionsList = res.data.array
                            array1[0].select = true
                            this.getDeptList(this.formParticipant.instutionsList[0])
                        }


                    })
                }catch (e) {
                }
            },
            //获取科室
            async getDeptList(item){
                try {
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.instutionsList.length;i++){
                            let obj=this.formParticipant.instutionsList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        institution_id: item.institution_id
                    }
                    this.formParticipant.instutionsHcpList = []
                    await http.post('/wapi/Conference/getDeptList',data).then(res=>{
                        if (res.success === true){
                            this.formParticipant.instutionsDeptList = res.data
                            this.activeDepart = this.formParticipant.instutionsDeptList[0].dept_id
                            this.getInstutionsHcpList(item.institution_id,this.formParticipant.instutionsDeptList[0].dept_id)
                        }
                    })
                }catch (e) {

                }
            },
            //实际参会选项卡点击
            handleDepart(type,event){
                let institution_id=''
                for (let i = 0;i<this.formParticipant.instutionsDeptList.length;i++) {
                    if (type.name === this.formParticipant.instutionsDeptList[i].dept_id) {
                        institution_id = this.formParticipant.instutionsDeptList[i].institution_id
                        break
                    }
                }
                this.formParticipant.instutionsHcpList = []
                this.getInstutionsHcpList(institution_id,type.name)
            },
            //获取医生
            async getInstutionsHcpList(institution_id,dept_id){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        institution_id:institution_id,
                        city_id: [],
                        segment_array:[],
                        dept_id:dept_id
                    }
                    await http.post('/wapi/Conference/getInstutionsHcpList',data).then(res=>{
                        if (res.success === true){
                            let array1 = res.data.array
                            let array2 = this.concatListCopy
                            for (let i =0;i<array1.length;i++){

                                // array1[i].department_name=array1[i].institution_name
                                array1[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (array1[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            array1[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            array1[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.instutionsHcpList = array1
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            //更改颜色
            colorFun(item){
                if (item.calls == '0' && item.campaigns == "0"){
                    return '#ED3B3F'
                } else {
                    return '#4A90E2'
                }
            },
            //选中hcp人员
            DepartClickHcp(obj,type){

                let splictFunction =  (obj)=>{
                    for (let i=0;i<this.concatListCopy.length;){
                        if (obj.reference_id === this.concatListCopy[i].reference_id ){
                            this.concatListCopy.splice(i,1)
                        } else {
                            i++
                        }
                    }
                }
                let select_numFunction = ()=>{
                    let array1=[]
                    let array2 = this.concatListCopy
                    if(this.selectType=='INSTITUTION'){
                        array1 = this.formParticipant.instutionsList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].institution_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }
                    }else if(this.selectType=='RETAILSTORE'){
                        array1 = this.formParticipant.retailStoreList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].store_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }

                    }else if(this.selectType=='DISTRIBUTOR'){
                         array1 = this.formParticipant.distributorList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].distributor_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }
                    }

                }

                if (type === 'uncheck1'){

                    obj.onoff = 'SPEAKER'
                    let item=obj
                    item.invited_role = obj.onoff
                    splictFunction(obj)
                    this.concatListCopy.push(item)
                    console.log(this.concatListCopy)
                    select_numFunction()
                }else if (type === 'uncheck2') {
                    obj.onoff = 'AUDIENCE'
                    let item=obj
                    item.invited_role = obj.onoff
                    splictFunction(obj)
                    this.concatListCopy.push(item)
                    console.log(this.concatListCopy)
                    select_numFunction()
                }else if (type === 'spcheck') {
                    obj.onoff = ''
                    splictFunction(obj)
                    select_numFunction()
                }else if (type === 'aucheck') {
                    obj.onoff = ''
                    splictFunction(obj)
                    select_numFunction()
                }

            },
            //添加讲者/听众
            addactualBoolModel(){
                // this.speakBool = true
                // this.selectType='INSTITUTION'
                // setTimeout(() => {
                //     this.getInstutionsList()
                // }, 200)
                //
                // this.instutionsHcpListCopy = JSON.parse(JSON.stringify(this.formParticipant.instutionsHcpList))
                this.speakBool = true
                if(this.clientObj.showInstitution){
                    this.selectType='INSTITUTION'
                    setTimeout(() => {
                        this.getInstutionsList()
                    }, 200)
                    this.instutionsHcpListCopy = JSON.parse(JSON.stringify(this.formParticipant.instutionsHcpList))
                }else if(!this.clientObj.showInstitution && this.clientObj.showStore){
                    this.selectType='RETAILSTORE'
                    setTimeout(() => {
                        this.getRetailstoreList()
                    }, 200)
                }else if(!this.clientObj.showInstitution && !this.clientObj.showStore && this.clientObj.showDistributor){
                    this.selectType='DISTRIBUTOR'
                    setTimeout(() => {
                        this.getDistributorList()
                    }, 200)
                }
                // else if(!this.clientObj.showInstitution && !this.clientObj.showStore && !this.clientObj.showDistributor){
                //     this.selectType = ''
                // }
            },
            //关闭实际参会模态框
            closeActualBool(){
                this.concatListCopy = JSON.parse(JSON.stringify(this.formParticipant.concatList))
                this.formParticipant.instutionsHcpList = JSON.parse(JSON.stringify(this.instutionsHcpListCopy))

                let array1 = this.formParticipant.instutionsList
                let array2 = this.concatListCopy
                for (let i=0;i<array1.length;i++){
                    array1[i].selectPeople_num = 0
                    for (let j=0;j<array2.length;j++){
                        if (array1[i].institution_id === array2[j].institution_id){
                            array1[i].selectPeople_num +=1
                        }
                    }
                }
                this.speakBool = false
            },
            //保存实际参会
            async saveActualBool(){

                this.formParticipant.concatList = JSON.parse(JSON.stringify(this.concatListCopy))
                for (let i =0;i<this.formParticipant.concatList.length;i++){
                    this.formParticipant.concatList[i].attendant_role = ''
                    this.formParticipant.concatList[i].invited = 'T'
                    this.formParticipant.concatList[i].attendant = 'F'
                }
                let user = this.$store.getters.getUser

                let data={
                    tenant_id : user.tenant_id,
                    etms_activity_campaign_participant:this.formParticipant.concatList,
                    campaign_id:this.activity_id ? this.activity_id : '',
                    attendant : 'F',
                    invited : 'T',
                    attendant_role : '',
                    type : 'INVITE',
                    user_id :user.user_id
                }
                this.speakBool = false
                //邀请客户名单的变更，不需要改变审批状态（也就是不需要再次提交）
                data.status = ''
                await http.post('/wapi/Conference/saveMeetingParticipant',data).then(res=>{
                    if (res.success === true){
                        this.getMeetingParticipant()
                        this.fatherMethod()
                        this.speakBool = false
                        this.$message({
                            type:'success',
                            message:'保存成功'
                        })
                    }
                })
                // if (this.meetInfoStatus === 'APPROVED') {
                //     this.$confirm('更改后需再次提交此计划, 确定保存?', '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         data.status = 'APPROVED'
                //          http.post('/wapi/Conference/saveMeetingParticipant',data).then(res=>{
                //             if (res.success === true){
                //                 this.getMeetingParticipant()
                //                 this.fatherMethod()
                //                 this.speakBool = false
                //                 this.$message({
                //                     type:'success',
                //                     message:'保存成功'
                //                 })
                //             }
                //         })
                //     }).catch(() => {
                //
                //         this.$message({
                //             type: 'info',
                //             message: '已取消保存'
                //         });
                //     });
                // }else {
                //
                // }


            },
            checkType(type){
                this.selectType=type
                if(type=='INSTITUTION'){
                    this.getInstutionsList()
                }else if(type=='RETAILSTORE'){
                    this.getRetailstoreList()
                }else if(type=='DISTRIBUTOR'){
                    this.getDistributorList()
                }
            },
           async delMeetingParticipant(item){

               this.$confirm('是否移除客户?', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               }).then(() => {
                   try {
                       let data = item
                       data.tenant_id = this.$store.getters.getUser.tenant_id
                       data.user_id =this.$store.getters.getUser.user_id
                       data.campaign_id = this.activity_id ? this.activity_id : ''
                       data.type = 'INVITE'
                       data.status = ''
                        http.post('/wapi/Conference/delMeetingParticipant',data).then(res=>{
                           if (res.success === true){
                               this.$message({
                                   type:'success',
                                   message:'移除成功'
                               })
                               this.fatherMethod()
                               this.getMeetingParticipant()

                           }
                       })
                       // if (this.meetInfoStatus === 'APPROVED') {
                       //     data.status = 'APPROVED'
                       //     this.$confirm('更改后需再次提交此计划, 确定保存?', '提示', {
                       //         confirmButtonText: '确定',
                       //         cancelButtonText: '取消',
                       //         type: 'warning'
                       //     }).then(() => {
                       //          http.post('/wapi/Conference/delMeetingParticipant',data).then(res=>{
                       //             if (res.success === true){
                       //                 this.$message({
                       //                     type:'success',
                       //                     message:'移除成功'
                       //                 })
                       //                 this.fatherMethod()
                       //                 this.getMeetingParticipant()
                       //
                       //             }
                       //         })
                       //     }).catch(() => {
                       //
                       //         this.$message({
                       //             type: 'info',
                       //             message: '已取消保存'
                       //         });
                       //     });
                       // }else {
                       //
                       // }


                   }catch (e) {
                       loading.close()
                   }

               }).catch(() => {
                   this.$message({
                       type: 'info',
                       message: '已取消'
                   });
               });


            },
            async getRetailstoreList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getRetailstoreList',data).then(res=>{
                       if(res.success==true){
                           this.formParticipant.retailStoreList=res.data.array
                           if(res.data.array.length>0){
                               let array2 = this.concatListCopy
                               for(let i=0;i<this.formParticipant.retailStoreList.length;i++){
                                   let obj=this.formParticipant.retailStoreList[i]
                                   obj.selectPeople_num=0
                                   obj.select=false
                                   for (let j=0;j<array2.length;j++){
                                       if (obj.store_id === array2[j].department_id){
                                           obj.selectPeople_num +=1
                                       }
                                   }
                               }
                               this.formParticipant.retailStoreList[0].select = true
                               this.getStorePeopleList(this.formParticipant.retailStoreList[0])
                           }else {
                               loading.close()
                           }

                       }
                    })

                }catch(e){

                }
            },
            async getStorePeopleList(item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.retailStoreList.length;i++){
                            let obj=this.formParticipant.retailStoreList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        retailstore_id:item.store_id,
                    }
                    await http.post('/wapi/Conference/getRetailstoreClerkList',data).then(res=>{
                        if(res.success==true){
                            let array2 = this.concatListCopy
                            for (let i =0;i<res.data.length;i++){
                                res.data[i].department_name=item.store_name
                                res.data[i].reference_obj='CLERK'
                                res.data[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (res.data[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            res.data[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            res.data[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.retailStoreClerk = res.data
                        }
                        loading.close()
                    })
                }catch (e) {

                }
            },
            async getDistributorList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/Business/getDistributorList',data).then(res=>{
                        if(res.success==true){
                            this.formParticipant.distributorList=res.data.array
                            if(res.data.array.length>0){
                                let array2 = this.concatListCopy
                                for(let i=0;i<this.formParticipant.distributorList.length;i++){
                                    let obj=this.formParticipant.distributorList[i]
                                    obj.selectPeople_num=0
                                    obj.select=false
                                    for (let j=0;j<array2.length;j++){
                                        if (obj.distributor_id === array2[j].department_id){
                                            obj.selectPeople_num +=1
                                        }
                                    }
                                }
                                this.formParticipant.distributorList[0].select = true
                                this.getDistributorContactList(this.formParticipant.distributorList[0])
                            }else {
                                loading.close()
                            }

                        }
                    })

                }catch(e){

                }
            },
            async getDistributorContactList(item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.distributorList.length;i++){
                            let obj=this.formParticipant.distributorList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        distributor_id:item.distributor_id,
                    }
                    await http.post('/wapi/Conference/getDistributorContactList',data).then(res=>{
                        if(res.success==true){
                            for (let i =0;i<res.data.length;i++){
                                res.data[i].department_name=item.distributor_name
                                res.data[i].reference_obj='CONTACT'
                                let array2 = this.concatListCopy
                                res.data[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (res.data[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            res.data[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            res.data[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.distributorContact = res.data
                        }
                        loading.close()
                    })
                }catch (e) {

                }
            },

        }

    }
</script>

<style scoped>
    .el-button-group >>> .el-button{
        padding: 8px 18px;
    }
    .active{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/customers.vue